<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <a v-if="isDownload" :href="url" :class="styles" download>
    <div class="w-6 h-6 p-1">
      <component :is="getSvg()" />
    </div>
    <div class="ml-3">{{ label }}</div>
  </a>
  <a v-else :href="url" :class="styles" :target="target">
    <div :class="[linkType === 'External' ? '-rotate-45' : '', 'w-6 h-6 p-1 ']">
      <component :is="getSvg()" />
    </div>
    <div class="ml-3">{{ label }}</div>
  </a>
</template>

<script lang="ts" setup>
import { computed, toRefs } from "vue";
import DownloadSvg from "./DownloadSvg.vue";
import LinkSvg from "./LinkSvg.vue";
import { LinkType as Type } from "@/types/IListComponent";
import { ThemeType } from "@/types/types";

export interface ListLinkProps {
  label: string;
  url: string;
  linkType?: Type;
  classes?: string;
  target?: string;
  themeType: ThemeType;
}

const props = defineProps<ListLinkProps>();
const { linkType, label, url, classes, themeType, target } = toRefs(props);

const buttonColor = computed(() => {
  return themeType.value === "dark"
    ? "text-white hover:text-orange"
    : "text-aubergine hover:text-orange";
});

const styles = computed(() => {
  return `relative inline-flex font-bold ${classes?.value} ${buttonColor.value} linkTransition`;
});

const isDownload = computed(() => {
  return linkType?.value === "Media";
});

const getSvg = () => {
  switch (linkType?.value) {
    case "Media":
      return DownloadSvg;
    default:
      return LinkSvg;
  }
};
</script>
